<template>
  <div>
    <el-form ref="formRef" :model="giftForm" label-width="100px">
      <el-form-item label="礼物名称：">
        <el-input v-model="giftForm.giftName" placeholder="10个字以内" style="width:24em;"/>
      </el-form-item>
      <el-form-item label="礼物价格：">
        <el-input v-model="giftForm.gold" placeholder="100000以内的正整数" style="width:20em;"/>&nbsp;&nbsp;个金币
      </el-form-item>
      <el-form-item label="赠送对象：">
        <el-select v-model="sex" placeholder="Select" style="width: 24em">
          <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="赠送次数：">
        <el-input v-model="giftForm.giftMax" placeholder="请输入赠送次数" style="width:24em;"/>
      </el-form-item>
      <el-form-item label="排序：">
        <el-input v-model="giftForm.orderNum" placeholder="排序，越大越靠前" style="width:24em;"/>
      </el-form-item>
      <el-form-item label="礼物图片：">
        <img :src="src" alt="" v-if="src" @click="headImgUpdate" class="cursor" style="width: 80px;height: 80px;margin: 0">
        <div class="add" @click="headImgUpdate" v-else>
          <span>+</span>
        </div>
        <input type="file" accept=".jp2,.jpe,.jpeg,.jpg,.png"  @change="headImgChanged" ref="headImg" multiple="multiple" style="display:none;">
      </el-form-item>
    </el-form>
    <div class="dialog-footer">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>

</template>

<script>
import { imgPostFormData } from "@/api/api"
import { addOrUpdateGift } from "@/api/url";

export default {
  name: "GiftManageDialog",
  props: {
    value: Object
  },
  data() {
    return {
      giftForm: this.value.giftForm,
      idx: this.value.ids,
      loading: false,

      files: null,
      src: this.value.ids > -1?this.value.giftForm.img:'',

      sexArray: [
        {label: '通用', value: 0},
        {label: '男', value: 1},
        {label: '女', value: 2},
      ],
      sex: this.value.giftForm.sex?this.value.giftForm.sex:0,

    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    summit() {
      if(!this.giftForm.giftName) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '名称不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.giftForm.gold) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '价格不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.giftForm.giftMax) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '赠送次数不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.giftForm.orderNum) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '排序不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.src) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '礼物图片不能为空',
          type: 'warning'
        });
        return false
      }
      this.loading = true
      let param = new FormData();
      if (this.idx > -1) {
        param.append('id', this.giftForm.id);
      } else {
        param.append('id', '0');
      }
      param.append('giftName', this.giftForm.giftName);
      param.append('gold', this.giftForm.gold);
      param.append('sex', this.sex);
      param.append('orderNum', this.giftForm.orderNum);
      param.append('giftMax', this.giftForm.giftMax);
      param.append('file', this.files);
      imgPostFormData(addOrUpdateGift, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm')
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
</style>
